<div class="work-packages--resizer icon-resizer-vertical-lines"></div>